import * as React from "react";

const SvgSpectrum = ({ ...props }) => (
  <svg
    version="1.0"
    xmlns="http://www.w3.org/2000/svg"
    width="512.000000pt"
    height="512.000000pt"
    viewBox="0 0 512.000000 512.000000"
    preserveAspectRatio="xMidYMid meet"
    {...props}
  >
    <g><path fill="currentColor" d="M 281.5,31.5 C 293.488,29.2332 300.988,33.8998 304,45.5C 320.676,155.223 337.676,264.889 355,374.5C 364.667,332.833 374.333,291.167 384,249.5C 385.833,245 389,241.833 393.5,240C 424.167,239.333 454.833,239.333 485.5,240C 494.482,244.473 497.649,251.64 495,261.5C 493.167,266 490,269.167 485.5,271C 461.169,271.5 436.836,271.667 412.5,271.5C 397.653,337.556 382.486,403.556 367,469.5C 364.193,476.487 359.027,479.82 351.5,479.5C 342.203,479.374 336.703,474.707 335,465.5C 318.853,359.803 302.519,254.136 286,148.5C 270.559,232.814 255.226,317.147 240,401.5C 235.643,415.257 226.809,419.09 213.5,413C 210.894,411.062 209.061,408.562 208,405.5C 191.121,336.983 173.788,268.65 156,200.5C 146.333,226.167 136.667,251.833 127,277.5C 125.167,282 122,285.167 117.5,287C 86.8333,287.667 56.1667,287.667 25.5,287C 16.5178,282.527 13.3511,275.36 16,265.5C 17.8333,261 21,257.833 25.5,256C 50.4057,255.828 75.239,255.328 100,254.5C 115.137,214.089 130.47,173.755 146,133.5C 152.945,126.931 160.778,125.764 169.5,130C 172.106,131.938 173.939,134.438 175,137.5C 190.177,198.542 205.511,259.542 221,320.5C 237.774,228.853 254.441,137.186 271,45.5C 272.085,38.9277 275.585,34.2611 281.5,31.5 Z"/></g>

  </svg>
);

export default SvgSpectrum;
